<div class="main-controls">
    <button
        class="btn-control click-outside-close-prevent btn-edit-action"
        [tooltip]="selectActionTooltip()"
        (click)="selectAction()"
    >
        <span class="sp-icon icon-pencil"> </span>
    </button>
    <div
        class="btn-group"
        dropdown
        (onShown)="isShowDropDownMenu(true)"
        (onHidden)="isShowDropDownMenu(false)"
        container="body"
    >
        <button class="btn-control dropdown-toggle" dropdownToggle type="button">
            <span class="sp-icon icon-option-horizontal"> </span>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-custom-right" role="menu">
            <li role="menuitem" [class.disabled]="disableCopyEvent()">
                <a class="dropdown-item" (click)="copyAction()">
                    <span class="sp-icon icon-copy"> </span>
                    {{ "duplicate" | translate }}
                </a>
            </li>
            <li><hr /></li>
            <li
                role="menuitem"
                [class.disabled]="disableRemoveEvent()"
                [tooltip]="disableRemoveEvent() ? disableRemoveEventTooltip() : ''"
                placement="bottom"
            >
                <a class="dropdown-item" (click)="deleteAction()">
                    <span class="sp-icon icon-bin color-danger"> </span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
